import { createContext, useContext, useState } from 'react';
import { parseAttributionFromUrl } from './parseAttribution.js';

const AttributionContext = createContext(null);
const STORAGE_KEY = 'ssi_attribution';

export function AttributionProvider({ children }) {
  const [attribution] = useState(() => {
    const fromUrl = parseAttributionFromUrl(
      window.location.search,
      document.referrer,
      window.location.pathname,
      window.location.hostname
    );

    // 1. URL gave us a real channel signal — use it, persist for the session.
    if (fromUrl.channel !== 'direct') {
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(fromUrl));
      } catch (e) { /* sessionStorage unavailable — proceed with in-memory only */ }
      return fromUrl;
    }

    // 2. No fresh signal — fall back to a previously-captured value.
    try {
      const stored = sessionStorage.getItem(STORAGE_KEY);
      if (stored) return JSON.parse(stored);
    } catch (e) { /* malformed JSON or no storage — fall through */ }

    // 3. First load with no params and no storage — direct visit.
    return fromUrl;
  });

  // Expose for in-browser debugging, mirroring the static site's window.__SSI_ATTRIBUTION__.
  if (typeof window !== 'undefined') window.__SSI_ATTRIBUTION__ = attribution;

  return (
    <AttributionContext.Provider value={attribution}>
      {children}
    </AttributionContext.Provider>
  );
}

export function useAttribution() {
  const ctx = useContext(AttributionContext);
  if (ctx === null) {
    throw new Error('useAttribution must be used inside <AttributionProvider>');
  }
  return ctx;
}
